// <tri-line-count> — the live "Import N songs" behaviour on the bulk
// import screen. Markup convention:
//
//   <tri-line-count>
//     <textarea name="import[rows]">Title,ISWC
//   Paper Cathedrals,T-070.245.891-2</textarea>
//     <button type="submit" data-line-count-submit>
//       Import <span data-line-count-value>0</span> songs
//     </button>
//   </tri-line-count>
//
// Counts non-empty data lines in the wrapped textarea, skipping a
// Title/ISWC header row (same detection the server import applies, so the
// number on the button matches what will actually import), writes N into
// every [data-line-count-value], and disables [data-line-count-submit] at
// zero. Without JS the button stays enabled with its server-rendered
// label — the count is a nicety, the form still submits.

const HEADER_ROW = /^\s*title\s*[,\t]/i;

class TriLineCount extends HTMLElement {
	#lifetime: AbortController | null = null;

	connectedCallback() {
		const textarea = this.querySelector<HTMLTextAreaElement>("textarea");
		if (!textarea) return;

		this.#lifetime?.abort();
		this.#lifetime = new AbortController();

		textarea.addEventListener("input", () => this.#update(textarea), {
			signal: this.#lifetime.signal,
		});
		this.#update(textarea);
	}

	disconnectedCallback() {
		this.#lifetime?.abort();
	}

	#update(textarea: HTMLTextAreaElement) {
		const count = textarea.value
			.split("\n")
			.filter(
				(line, index) =>
					line.trim() !== "" && !(index === 0 && HEADER_ROW.test(line)),
			).length;

		for (const el of this.querySelectorAll("[data-line-count-value]")) {
			el.textContent = count.toString();
		}
		for (const el of this.querySelectorAll("[data-line-count-submit]")) {
			el.toggleAttribute("disabled", count === 0);
		}
	}
}

if (!customElements.get("tri-line-count")) {
	customElements.define("tri-line-count", TriLineCount);
}
